import React, { useState } from 'react';
import { Button, Card, Col, Form, Input, Modal, Select, notification, Row } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { authAxios } from '../../services/auth-axios';

export function EditUserModal({ user, onUserEdit }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const roles = localStorage.getItem('roles');
  const isAdmin = roles && roles.includes('ADMIN');

  const open = () => setModalOpen(true);

  const close = () => setModalOpen(false);

  const handleEditUser = async (values) => {
    setLoading(true);
    try {
      const { userType, ...profileValues } = values;
      await authAxios().put(`/users/${user.id}`, { ...user, ...profileValues });

      if (isAdmin && userType && userType !== user.userType) {
        await authAxios().patch(`/users/${user.id}/type`, { userType });
      }
      notification.success({ message: 'Usuário editado com sucesso!' });
    } catch (error) {
      console.error('Error adding user:', error);
      notification.error({ message: 'Erro ao editar usuário', description: error.response.data.message });
    } finally {
      onUserEdit?.();
      setLoading(false);
      close();
    }
  };

  return (
    <>
      <Button
        type="primary"
        onClick={open}
        size="large"
        style={{ backgroundColor: 'orange' }}
        icon={<EditOutlined />}
        aria-label="Editar usuário"
      />

      <Modal open={modalOpen} onCancel={close} footer={null} afterClose={form.resetFields}>
        <Card title="Editar Usuário">
          <Form layout="vertical" onFinish={handleEditUser} form={form} id="editUserForm" initialValues={user}>
            <Form.Item name="name" label="Nome completo">
              <Input placeholder="Digite o nome completo" />
            </Form.Item>

            <Form.Item name="cpf" label="CPF">
              <Input placeholder="Digite o CPF completo" />
            </Form.Item>

            <Form.Item name="phone" label="Telefone">
              <Input placeholder="Digite o seu telefone com DDD" />
            </Form.Item>

            <Form.Item name="email" label="Email" rules={[{ type: 'email', message: 'Isso não parece um e-mail válido 🤔' }]}>
              <Input placeholder="Digite o e-mail" />
            </Form.Item>

            {isAdmin && (
              <Form.Item name="userType" label="Tipo do usuário">
                <Select
                  data-testid="edit-user-type-select"
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  options={[
                    { value: 'REGULAR', label: 'Regular' },
                    { value: 'ADMIN', label: 'Administrador' },
                  ]}
                />
              </Form.Item>
            )}

            <Form.Item>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Button disabled={loading} form="editUserForm" htmlType="submit" type="primary" block>
                    Editar usuário
                  </Button>
                </Col>
                <Col span={24}>
                  <Button disabled={loading} block type="dashed" onClick={close}>
                    Fechar
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </>
  );
}
